import styled from 'styled-components';

import { ReactComponent as BaseIconBack } from 'assets/images/icon-back.svg';
import { ReactComponent as BaseIconClose } from 'assets/images/icon-close.svg';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 0 16px;
  background-color: #f9f9f9;

  @media ${({ theme }) => theme.device.mobile} {
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 5;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  height: 70px;
`;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  box-shadow: 0 6px 10px 0 rgba(128, 98, 96, 0.16);
  background-color: #ffffff;
  border-radius: 100%;
  cursor: pointer;
`;

export const Title = styled.h4`
  font-size: 18px;
  font-weight: 600;
`;

export const IconBack = styled(BaseIconBack)`
  height: 15px;
`;

export const IconClose = styled(BaseIconClose)`
  width: 11px;
`;

export const Spacer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
`;

export const RightButton = styled.button`
  background: none;
  border: none;

  color: #F4BF31;
  font-size: 16px;
  font-weight: 600;
`;
